import { API } from "aws-amplify";

import { makeBearerAuth } from "data/libs/authLib";

class Client {
  constructor(factory, callPost) {
    this.factory = factory;
    this.callPost = callPost;
  }

  async query(variables, { query, resolver }, _, options) {
    const request = await this.factory({ query, variables }, options);
    const response = await this.callPost(request);
    return { result: resolver(response) };
  }
}

export const createProdClient = (headers) => {
  const callPost = async (req) => {
    return API.post("HublyAPI", `/graphql`, req);
  };

  const factory = async (body, o) => {
    const makeEmptyAuth = async () => {
      return "";
    };

    const getAuth = o?.skipAuth || false ? makeEmptyAuth : makeBearerAuth;
    const authHeader = { Authorization: await getAuth() };

    return { body: body, headers: { ...authHeader, ...headers } };
  };

  return new Client(factory, callPost);
};

export default createProdClient;
